import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import {
    EMPTY_CHANGE_VALUE,
    EMPTY_VALUE,
} from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/constants";

import * as SC from "./styles";

const Empty = () => (
    <SC.Container>
        <SC.LeftSection>
            <SC.MainValue>{EMPTY_VALUE}</SC.MainValue>

            <SC.ChangeChip>
                <ChangeIndication
                    className="customChangeIndication"
                    changeValue={EMPTY_CHANGE_VALUE}
                    isIncreasing={true}
                    isNotChanged={false}
                />
            </SC.ChangeChip>
        </SC.LeftSection>
    </SC.Container>
);

export default Empty;
